import {
  ASSISTANT_SURFACE_TARGET_TEXT_MAX_LENGTH,
  toAssistantSurfaceTargetText,
} from './assistantSurfacePlainText'

// TripPlannerSurfaceActivityEntry.displayText is required (never undefined), but
// toAssistantSurfaceTargetText can return undefined if sanitizing collapses the input to nothing.
// Every current builder composes displayText from non-empty literal text plus an interpolated
// part, so the literal text alone survives sanitization regardless of what's interpolated -- this
// can't happen in practice today, but the fallback keeps the return type honest and still bounded
// (a raw slice, skipping sanitization) rather than assuming it can never happen.
export function boundActivityDisplayText(displayText: string): string {
  return toAssistantSurfaceTargetText(displayText) ?? displayText.slice(0, ASSISTANT_SURFACE_TARGET_TEXT_MAX_LENGTH)
}
